import { hangzhounet, mainnet } from '@versumstudios/rpc-node';
/* eslint-disable @typescript-eslint/no-explicit-any */
export const preview = (wallet: string, constrain = 5) => {
  try {
    return `${wallet.slice(0, constrain)}...${wallet.slice(wallet.length - constrain, wallet.length)}`;
  } catch (e) {
    return '';
  }
};

export const getAliasFromWallet = (wallet: string, _names: any[], type: number) => {
  // this code trusts that `names` is correctly sync with information with .eth and .tez domains.
  // at the moment it isn't.
  switch (type) {
    // tezos
    // case 0:
    //   if (names[0]) {
    //     return `${names[0].name}.tez`;
    //   }
    //   return preview(wallet);
    // // eth
    // case 1:
    //   if (names[0]) {
    //     return `${names[0].name}.eth`;
    //   }
    //   return preview(wallet);
    default:
      return preview(wallet);
  }
};

export const getWalletExplorer = (wallet: string): string => {
  if (wallet.startsWith('tz')) {
    // return tezos indexer
    return `https://tzkt.io/${wallet}`;
  }

  if (wallet.startsWith('0x')) {
    return `https://etherscan.io/address/${wallet}`;
  }

  return '';
};

export const buildNodesFromNetwork = (network: string) => {
  let nodes = [];

  if (network === 'mainnet') {
    nodes = mainnet;
  }

  if (network === 'hangzhounet') {
    nodes = hangzhounet;
  }

  return nodes.map((node: string) => {
    return { value: `https://${node}`, label: node };
  });
};
